/**
 * Format a phone number to something that sounds better read by reader.
 *     "1800.INSIGHT" returns "1. 8 0 0. 4 6 7. 4 4 4 8."
 *     "+33 (0)1 30 67 25 00" returns "+ 3 3. 0 1. 3 0. 6 7. 2 5. 0 0."
 * @param  {String} phoneNumber      phoneNumber to convert
 * @return {String}                  phoneNumber formatted for aria
 **/
export function ariaPhoneFormat( phoneNumber ) {
  // Convert INSIGHT to its numeric equivalent in order to add the pause.
  phoneNumber = phoneNumber.replace(/insight/gi,"467.4448");
  // Convert alphabet to numbers.
  phoneNumber = phoneNumber.replace(/[abc]/gi,"2").replace(/[def]/gi,"3").replace(/[ghi]/gi,"4").replace(/[jkl]/i,"5").replace(/[mno]/i,"6").replace(/[pqrs]/i,"7").replace(/[tuv]/i,"8").replace(/[wxyz]/i,"9");
  // Remove unnecessary characters
  phoneNumber = phoneNumber.replace(/[\/()]/g,"");
  // Convert periods to space
  phoneNumber = phoneNumber.replace(/[.-]/g," ");
  // If starting with 1800 at the beginning of the line, insert a space between the 1 and the 8.
  phoneNumber = phoneNumber.replace(/^1800/,"1 800")
  // Convert multiples spaces to single space
  phoneNumber = phoneNumber.replace(/\s+/g," ");
  // Convert spaces into period, space in order to force a screen reader pause.
  phoneNumber = phoneNumber.replace(/ /g,". ");
  // Place spaces between numbers to force reader to read each number separately.
  phoneNumber = phoneNumber.replace(/([\d+])(?=\d)/g,"$1 ");
  // Remove spaces before period.
  phoneNumber = phoneNumber.replace(/ \./g,".");
  return phoneNumber + ".";
}
